// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/_defined.js
// module id = 48
// module chunks = 48 49 50 51